import { Component, Inject, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { LocalStorageService } from 'services/local-storage.service';
import { DOCUMENT } from '@angular/common';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatIconRegistry } from '@angular/material/icon';

@Component({
  selector: 'sk-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
  constructor(iconRegistry: MatIconRegistry,
              private storage: LocalStorageService,
              private snackbar: MatSnackBar,
              @Inject(DOCUMENT) private document: Document,
              sanitizer: DomSanitizer) {
    iconRegistry.addSvgIcon(
      'dashboard',
      sanitizer.bypassSecurityTrustResourceUrl('assets/img/baseline_dashboard_navy_blue.svg'));

  }

  ngOnInit() {
    this.languageListener();

  }


  languageListener() {
    const language = this.storage.getStorage('language');
    if (!language) {
      return;
    }
    // user saved in indexDB
    const urlOrigin = this.document.location.origin;
    const url = this.document.location.href;
    if (url.includes('localhost')) {
      return;
    }
    switch (language) {
      case 'nl-NL':
        if (url.includes('/nl')) {
          return;
        }
        this.snackbar.open('Nederlands laden...', 'Ok');
        this.document.location.replace(`${urlOrigin}/nl/`);
        console.log('NL Scenario');
        break;
      case 'en-US':
        if (url.includes('/en')) {
          return;
        }
        this.snackbar.open('Loading English...', 'Ok');
        this.document.location.replace(`${urlOrigin}/en/`);
        console.log('EN Scenario');
        break;
      case 'es-US':
        if (url.includes('/es')) {
          return;
        }
        this.snackbar.open('Cargando idioma español...', 'Ok');
        this.document.location.replace(`${urlOrigin}/es/`);
        console.log('ES Scenario');
        break;
    }
  }


}
